export default "__VITE_ASSET__CYUF40ps__"